<template>
  <v-container grid-list-xl>
    <v-layout row wrap>
      <site-control :selectedProject="project"></site-control>
      <site-view></site-view>
    </v-layout>
  </v-container>
</template>

<script>
import Store from "@/store/computed/storeHelpers";
import SiteControl from "@/components/sites/siteControl";
import SiteView from "@/components/sites/siteView";
export default {
  data() {
    return {
      fid: Number(this.$route.query.fid)
    };
  },
  mounted() {
    !!this.fid && (this.project = this.fid);
  },
  props: {
    // project: {
    //     type: Number,
    //     default: null
    // }
  },
  components: {
    SiteControl,
    SiteView
  },
  computed: {
    project: Store.getSet({ store: "sites", prop: "project" })
  }
};
</script>

<style scoped>
.list-complete-item {
  transition: all 1s;
  display: inline-block;
  margin-right: 10px;
}
.list-complete-enter, .list-complete-leave-to
        /* .list-complete-leave-active below version 2.1.8 */ {
  opacity: 0;
  transform: translateY(30px);
}
.list-complete-leave-active {
  position: absolute;
}
</style>
